import { render, staticRenderFns } from "./EditAnnouncement.vue?vue&type=template&id=2f049634"
import script from "./EditAnnouncement.vue?vue&type=script&lang=js"
export * from "./EditAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports